import { RootState } from '..';

export function getHighVisibilityMode(state: RootState) {
  return state.visualOptions.highVisibilityMode;
}
